var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbPushToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.99 1.418a1.429 1.429 0 012.02 0l8.572 8.572a1.429 1.429 0 01-2.02 2.02l-6.133-6.133V22.43a1.429 1.429 0 01-2.858 0V5.877L4.44 12.01a1.429 1.429 0 01-2.02-2.02l8.57-8.572z",
    fill: "#58647A"
  })));
}

export default SvgIbPushToTop;